import {
  CustomDialogConfiguration,
  Field,
  ListItem,
  Octopus,
} from '@maximizer/core/shared/domain';
import { ActionArgs, ActionEventType } from './actions';

export class ShowAddressDialogArgs extends ActionArgs {
  constructor(
    public fieldId: string,
    public tag: string,
    public addressKey?: string | null,
    public parentKey?: string | null,
    public isNew?: boolean,
    public canUpdateDefault?: boolean,
  ) {
    super(ActionEventType.ShowDialog);
  }
}

export class ShowPreviewDialogArgs extends ActionArgs {
  constructor(
    public tag: string,
    public key: string,
    public fileName: string,
    public autoOpen: boolean = true,
  ) {
    super(ActionEventType.ShowDialog);
  }
}

export class ShowCustomDialogArgs extends ActionArgs {
  constructor(
    public fieldId: string,
    public field: Field,
    public tag: string,
    public configuration?: CustomDialogConfiguration,
    public iFrame = false,
  ) {
    super(ActionEventType.ShowCustomDialog);
  }
}

export class CloseDialogArgs extends ActionArgs {
  constructor(public value: unknown) {
    super(ActionEventType.ReturnDialogResult);
  }
}

export class CloseCustomDialogArgs extends ActionArgs {
  constructor(public value: unknown) {
    super(ActionEventType.ReturnCustomDialogResult);
  }
}

export class ShowDialogArgs extends ActionArgs {
  [key: string]: unknown;

  constructor(
    public tag: string,
    public key: string | string[],
    public title?: string,
  ) {
    super(ActionEventType.ShowDialog);
  }
}

export class ShowWorkflowListViewDialogArgs extends ActionArgs {
  constructor(
    public tag: string,
    public keys: string[],
    public id?: string,
    public title?: string,
    public field?: ListItem<string>,
    public workFlowId?: string,
  ) {
    super(ActionEventType.ShowDialog);
  }
}

export interface ShowTaskDialogOptions {
  tag: string;
  key?: string;
  workflowId?: string;
  isTemplate?: boolean;
  canEdit?: boolean;
  sequence?: number;
  isSequential?: boolean;
  workflowStageId?: string;
  entityKey?: string;
  activityKey?: string;
  suppressFollowUp?: boolean;
  ignoreConflictChecking?: boolean;
  version?: number;
  entityType?: Octopus.EntityType;
}

export class ShowTaskDialogArgs extends ActionArgs {
  [key: string]: unknown;

  tag: string;
  key?: string;
  workflowId?: string;
  isTemplate?: boolean;
  canEdit?: boolean;
  sequence?: number;
  isSequential?: boolean;
  workflowStageId?: string;
  entityKey?: string;
  activityKey?: string;
  suppressFollowUp?: boolean;
  ignoreConflictChecking?: boolean;
  version?: number;
  entityType?: Octopus.EntityType;

  constructor(options: ShowTaskDialogOptions) {
    super(ActionEventType.ShowDialog);
    this.tag = options.tag;
    this.key = options.key;
    this.workflowId = options.workflowId;
    this.isTemplate = options.isTemplate;
    this.canEdit = options.canEdit;
    this.sequence = options.sequence;
    this.isSequential = options.isSequential;
    this.workflowStageId = options.workflowStageId;
    this.entityKey = options.entityKey;
    this.activityKey = options.activityKey;
    this.suppressFollowUp = options.suppressFollowUp;
    this.ignoreConflictChecking = options.ignoreConflictChecking;
    this.version = options.version;
    this.entityType = options.entityType;
  }
}

export class OpenPhotoUploadDialogArgs extends ActionArgs {
  constructor(public entity: { key?: string }) {
    super(ActionEventType.OpenPhotoUpload);
  }
}

export class OpenEditKeyFieldsDialogArgs extends ActionArgs {
  constructor(public url: string) {
    super(ActionEventType.EditKeyFields);
  }
}

export interface DialogReturnArgs<T = unknown> {
  fieldId: string;
  field: Field;
  value: T;
}

export interface ReturnWorkflowEntryListViewCloseDialogArgs {
  type: string;
  id: string;
}
